import CaseUnits from "./caseUnits";

/** FZ lab units — same table as Units, blank fields except CRM completer. */
const CaseFzUnits = () => <CaseUnits variant="fz" />;

export default CaseFzUnits;
